import { DOMAIN_FRAGMENT } from 'features/inventory/api/fragments/domain'
import { Ability } from 'providers/casl/types/ability'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_DOMAIN = (
  ability: Ability,
): TypedDocumentNode<Data, { input: Variables }> => gql`
  ${DOMAIN_FRAGMENT({ ability })}
  ${ERROR_FRAGMENT}

  mutation updateDomain($input: UpdateDomainInput!) {
    updateDomain(input: $input) {
      domain {
        ...DomainFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
